import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-cards-dashboard',
    imports: [],
    templateUrl: './cards-dashboard.component.html',
})
export class CardsDashboardComponent {

    @Input() todayTotal: number = 0;
    @Input() previousTotal: number = 0;
    @Input() branchesTotal: number = 0;
}
